import { Modal, Form, Input, Select, Switch } from 'antd'
import { useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { useStore } from '../../hooks'
import { showMessageSuccess } from 'src/helpers/functions'

const { Option } = Select

interface EditWhitelistProps {
   visible: boolean
   item: any
   onOk: () => void
   onCancel: () => void
}

const EditWhitelist = observer(({ visible, item, onOk, onCancel }: EditWhitelistProps) => {
   const WhitelistStore = useStore('WhitelistStore')
   const [form] = Form.useForm()
   const [loading, setLoading] = useState(false)

   useEffect(() => {
      if (item) {
         form.setFieldsValue({
            ip: item.ip,
            group: item.group,
            username: item.username,
            note: item.note,
            isActive: item.isActive
         })
      }
   }, [item, form])

   const handleOk = async () => {
      try {
         const values = await form.validateFields()
         setLoading(true)
         const result = await WhitelistStore.updateWhitelist(item.id, {
            ip: values.ip,
            group: values.group,
            username: values.username || null,
            note: values.note || null,
            isActive: values.isActive
         })
         if (result) {
            showMessageSuccess('Cập nhật whitelist thành công')
            onOk()
         }
      } catch (error) {
         // validation error
      } finally {
         setLoading(false)
      }
   }

   return (
      <Modal
         title="Sửa Whitelist"
         visible={visible}
         onOk={handleOk}
         onCancel={onCancel}
         confirmLoading={loading}
         okText="Cập nhật"
         cancelText="Hủy"
      >
         <Form form={form} layout="vertical">
            <Form.Item name="ip" label="IP" rules={[{ required: true, message: 'Vui lòng nhập IP' }]}>
               <Input placeholder="Nhập địa chỉ IP" />
            </Form.Item>
            <Form.Item name="group" label="Nhóm" rules={[{ required: true, message: 'Vui lòng chọn nhóm' }]}>
               <Select placeholder="Chọn nhóm">
                  <Option value="delivery">Delivery</Option>
                  <Option value="webhook">Webhook</Option>
                  <Option value="order">Order</Option>
               </Select>
            </Form.Item>
            <Form.Item name="username" label="Username">
               <Input placeholder="Nhập username (không bắt buộc)" />
            </Form.Item>
            <Form.Item name="note" label="Ghi chú">
               <Input.TextArea placeholder="Nhập ghi chú" rows={3} />
            </Form.Item>
            <Form.Item name="isActive" label="Trạng thái" valuePropName="checked">
               <Switch checkedChildren="Bật" unCheckedChildren="Tắt" />
            </Form.Item>
         </Form>
      </Modal>
   )
})

export default EditWhitelist
